// Google Maps API loader utility

let isLoading = false;
let isLoaded = false;
const callbacks: (() => void)[] = [];

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_PLACES_API_KEY || process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

export const loadGoogleMapsAPI = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    // Check if Google Maps is already loaded (from HTML injection or previous load)
    if ((window as any).google && (window as any).google.maps && (window as any).google.maps.Map) {
      isLoaded = true;
      resolve();
      return;
    }
    
    // Check if script tag already exists in DOM (from HTML injection)
    const existingScript = document.querySelector('script[src*="maps.googleapis.com"]');
    if (existingScript) {
      // Wait for the existing script to load
      existingScript.addEventListener('load', () => {
        isLoaded = true;
        resolve();
      });
      
      existingScript.addEventListener('error', () => {
        reject(new Error('Failed to load Google Maps API'));
      });
      
      // If already loaded by the time we check
      if ((window as any).google && (window as any).google.maps) {
        isLoaded = true;
        resolve();
      }
      
      return;
    }
    
    // If already loaded by module state, resolve immediately
    if (isLoaded && (window as any).google && (window as any).google.maps) {
      resolve();
      return;
    }

    // Add to callback queue
    callbacks.push(resolve);

    // If already loading, don't load again
    if (isLoading) {
      return;
    }

    isLoading = true;

    // Create callback function name
    const callbackName = 'initGoogleMaps';
    (window as any)[callbackName] = () => {
      isLoaded = true;
      isLoading = false;
      callbacks.forEach(callback => callback());
      callbacks.length = 0; // Clear callbacks
      delete (window as any)[callbackName];
    };

    // Create script element
    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&callback=${callbackName}&libraries=places&loading=async&region=CA`;
    
    script.onerror = () => {
      isLoading = false;
      reject(new Error('Failed to load Google Maps API'));
    };

    // Append to head
    document.head.appendChild(script);
  });
};

export const isGoogleMapsLoaded = (): boolean => {
  const loaded = isLoaded && (window as any).google && (window as any).google.maps;
  return loaded;
};
